import React from "react";
import styles from "../Pricing.module.scss";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";

function OtherFees({ activeApp }) {
  const getPricingDataById = (id) => {
    let pricing = activeApp?.prices?.find((price) => price.id === id);
    return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
  };

  return (
    <>
      <div className={styles.default_fees}>
        <HeadingWithLine text="DEFAULT FEES" line={false} />
        <div className={styles.fees_grid}>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Setup fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(28).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Monthly Access fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(19).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>$100k Data Breach</div>
              <div className={styles.fee_value}>$ {getPricingDataById(42).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Monthly Minimum</div>
              <div className={styles.fee_value}>$ {getPricingDataById(18).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Semi-annual tech fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(43).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Voice ARU</div>
              <div className={styles.fee_value}>$ {getPricingDataById(12).dollars}/auth</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Batch fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(14).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Returned ACH item</div>
              <div className={styles.fee_value}>$ {getPricingDataById(22).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>AVS fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(13).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>3rd Party Auth/Txn</div>
              <div className={styles.fee_value}>$ {getPricingDataById(11).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>ETF fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(46).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Chargeback fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(20).dollars}/auth</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Representment fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(47).dollars}</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Pre-dispute fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(48).dollars}</div>
            </div>
          </div>

          {/* <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>EBT Fee</div>
              <div className={styles.fee_value}>{getPricingDataById(29).dollars}%/trans</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Gateway Fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(46).dollars}/mo</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Gateway Transaction Fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(47).dollars}/txn</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>SaaS Fee</div>
              <div className={`${styles.fee_value} ${styles.gray}`}>n/a</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Hardware Fee</div>
              <div className={styles.fee_value}>$ {getPricingDataById(48).dollars}/mo</div>
            </div>
          </div> */}

        </div>
      </div>

      <div className={styles.pin_debit}>
        <HeadingWithLine text="PIN-BASED DEBIT" />
        <div className={styles.fees_grid}>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Debit rate</div>
              <div className={styles.fee_value}>{getPricingDataById(5).percent}%</div>
            </div>
          </div>
          <div className={styles.fee_item}>
            <div className={styles.fee_content}>
              <div className={styles.fee_label}>Per Txn</div>
              <div className={styles.fee_value}>$ {getPricingDataById(5).dollars}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OtherFees; 